/* NUVRA Set 1-2-3 — pagina produsului.
 * Formula comerciala: 1 produs = pretul actual; 2 produse din aceeasi categorie = EXTRA -10% la valoarea setului;
 * 3 produse = EXTRA -17% la valoarea setului (fara cumul). Reducerea reala vine din reducerile automate native Shopify
 * (una pe categorie si prag), deci formularul EasySell si comanda Shopify primesc aceleasi sume.
 * Calculul de aici reproduce exact regula Shopify, verificata in testul din 03.11 cu reduceri reale: reducerea se
 * calculeaza pe fiecare bucata si se rotunjeste IN JOS la ban (T01 198,99: 10% = 19,89; 17% = 33,82 pe bucata).
 * Economie la produse = (pret anterior valid - pret actual, doar unde exista) + reducerea EXTRA a setului.
 * Transportul NU se alege aici: metoda se alege doar in formularul EasySell (acasa 29,99 / Easybox 19,99, ambele gratuite
 * de la 299 lei dupa reduceri). Economia de transport si economia TOTALA se afiseaza in formular, dupa alegerea metodei. */
(function () {
  'use strict';
  var root = document.querySelector('[data-nvs]');
  if (!root || root.__nvs) return;
  root.__nvs = true;

  var cfg = JSON.parse(root.querySelector('[data-nvs-cfg]').textContent);
  var TIER_PCT = [0, 0, 10, 17]; // dupa numarul de produse din set
  var ORD = ['', 'a doua', 'a treia'];
  var CHUNK = 24;
  var $ = function (s, el) { return (el || root).querySelector(s); };
  var pageRoot = document.getElementById('nuvra-product-root') || document.body;

  var state = { tier: 1, slots: [cfg.p1, null, null], picking: 0 };

  // ─── calcule ────────────────────────────────────────────────────────────────
  function extraOf(price, pct) { return Math.floor((price * pct + 50) / 100); }
  function money(b) {
    return (b / 100).toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' lei';
  }
  // Liniile din cos: acelasi model ales de mai multe ori = o singura linie cu cantitate (asa il grupeaza si Shopify).
  function calc(items) {
    var n = items.length, pct = TIER_PCT[n] || 0, map = {}, lines = [];
    items.forEach(function (it) {
      if (!map[it.v]) { map[it.v] = { it: it, qty: 0 }; lines.push(map[it.v]); }
      map[it.v].qty++;
    });
    var r = { n: n, pct: pct, lines: lines, base: 0, extra: 0, prev: 0, old: 0 };
    lines.forEach(function (L) {
      var lp = L.it.p * L.qty;
      L.extra = L.qty * Math.floor(L.it.p * pct / 100);
      r.base += lp; r.extra += L.extra;
      if (L.it.c > L.it.p) { r.prev += (L.it.c - L.it.p) * L.qty; r.old += L.it.c * L.qty; } else r.old += lp;
    });
    r.subtotal = r.base - r.extra;
    r.total = r.subtotal;
    r.free = r.subtotal >= cfg.free;
    r.save = r.prev + r.extra;
    return r;
  }
  function compute() {
    var items = state.slots.slice(0, state.tier);
    var r = calc(items.filter(Boolean));
    r.complete = items.every(Boolean);
    return r;
  }
  // Previzualizare pentru cardurile ofertelor: modelele deja alese, iar pozitiile inca libere = modelul paginii
  // (ex. Finet T01 198,99 lei: 2 produse = 358,20 lei, 3 produse = 495,51 lei, ca in cosul Shopify).
  function computeFor(n) {
    var items = [], preview = false;
    for (var i = 0; i < n; i++) { if (!state.slots[i]) preview = true; items.push(state.slots[i] || cfg.p1); }
    var r = calc(items); r.preview = preview;
    return r;
  }
  var BADGE = ['', 'Mai avantajos', 'Cea mai bună ofertă'];
  var CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function tierHTML(n) {
    var r = computeFor(n);
    var h = '<span class="nvs-tier__radio" aria-hidden="true"></span>';
    if (BADGE[n - 1]) h += '<span class="nvs-tier__badge">' + BADGE[n - 1] + '</span>';
    h += '<span class="nvs-tier__n">' + n + (n === 1 ? ' produs' : ' produse') + '</span>';
    h += '<strong class="nvs-tier__now">' + money(r.subtotal) + '</strong>';
    h += '<span class="nvs-tier__ship' + (r.free ? ' is-free' : '') + '">' +
      (r.free ? CHECK + 'Transport GRATUIT' : '+ transport de la ' + money(cfg.ebox)) + '</span>';
    h += r.old > r.subtotal ? '<del class="nvs-tier__old">' + money(r.old) + '</del>' : '<span></span>';
    if (r.save > 0) h += '<span class="nvs-tier__save"><span>Economisești la produse</span><b>' + money(r.save) + '</b></span>';
    var parts = [];
    if (r.extra) parts.push('reducerea EXTRA a setului ' + money(r.extra));
    if (r.prev) parts.push('reducerile existente ' + money(r.prev));
    if (parts.length || r.free) h += '<span class="nvs-tier__why">' + (parts.length ? 'Include ' + parts.join(' + ') + '.' : '') +
      (r.free ? ' Transport gratuit inclus.' : '') + '</span>';
    return h;
  }
  // Nota scurta sub oferte cat timp ofertele 2/3 sunt calculate pentru acelasi model.
  function previewNote() {
    var pending = state.slots.slice(1, 3).some(function (x) { return !x; });
    var el = $('[data-nvs-note]');
    if (el) el.hidden = !pending;
  }

  // ─── stoc ───────────────────────────────────────────────────────────────────
  // Cate bucati din aceeasi varianta sunt deja in set (fara pozitia care se schimba).
  function usedElsewhere(v, exceptIdx) {
    var n = 0;
    state.slots.slice(0, state.tier).forEach(function (s, i) { if (s && i !== exceptIdx && s.v === v) n++; });
    return n;
  }
  function canTake(it, idx) { return it.q == null || usedElsewhere(it.v, idx) + 1 <= it.q; }

  // ─── randare principala ────────────────────────────────────────────────────
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function img(it, cls) {
    return it.i ? '<img class="' + cls + '" src="' + esc(it.i) + '" alt="" width="120" height="120" loading="lazy" decoding="async">' : '<span class="' + cls + ' nvs-noimg"></span>';
  }

  function render() {
    var multi = state.tier > 1;
    document.body.classList.toggle('nvs-multi', multi);
    pageRoot.classList.toggle('nvs-multi', multi);
    [].forEach.call(root.querySelectorAll('[data-nvs-tier]'), function (b) {
      var n = Number(b.getAttribute('data-nvs-tier'));
      b.innerHTML = tierHTML(n);
      previewNote();
      var on = n === state.tier;
      b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    $('[data-nvs-body]').hidden = !multi;
    if (!multi) return;

    var r = compute();
    var html = '';
    for (var i = 0; i < state.tier; i++) {
      var L = state.slots[i] ? { it: state.slots[i] } : null;
      html += '<li class="nvs-slot' + (L ? ' is-full' : '') + '"><p class="nvs-slot__k">Produsul ' + (i + 1) +
        (i ? '' : ' · <span class="nvs-slot__here">modelul de pe această pagină</span>') + '</p>';
      if (L) {
        html += '<div class="nvs-slot__row">' + img(L.it, 'nvs-slot__img') + '<div class="nvs-slot__info"><p class="nvs-slot__t">' + esc(L.it.t) + '</p>' + (L.it.s ? '<p class="nvs-slot__s">Cod ' + esc(L.it.s) + '</p>' : '') + '<p class="nvs-slot__p">';
        html += (L.it.c > L.it.p ? '<del>' + money(L.it.c) + '</del> ' : '') + '<strong>' + money(L.it.p) + '</strong>';
        html += '</p>' + (i ? '<button type="button" class="nvs-change" data-nvs-pick="' + i + '">Schimbă modelul</button>' : '') + '</div></div>';
      } else {
        html += '<button type="button" class="nvs-pick" data-nvs-pick="' + i + '"><span aria-hidden="true">+</span> Alege modelul</button>';
      }
      html += '</li>';
    }
    $('[data-nvs-slots]').innerHTML = html;

    var sum = $('[data-nvs-sum]');
    sum.hidden = !r.complete;
    var cta = $('[data-nvs-cta]');
    var sb = $('[data-nvs-sbar-btn]'), st = $('[data-nvs-sbar-t]'), ss = $('[data-nvs-sbar-s]');
    if (r.complete) { st.textContent = money(r.total) + (r.free ? '' : ' + transport'); ss.textContent = 'Economisești ' + money(r.save) + ' la produse'; sb.textContent = 'Comandă setul'; }
    else { var mi = state.slots.slice(0, state.tier).indexOf(null); st.textContent = 'Setul de ' + state.tier; ss.textContent = 'Mai ai de ales un model'; sb.textContent = 'Alege ' + ORD[mi] + ' ' + cfg.noun; }
    if (r.complete) {
      $('[data-nvs-items]').textContent = money(r.base);
      $('[data-nvs-extra]').textContent = '−' + money(r.extra);
      $('[data-nvs-shipcost]').textContent = r.free ? 'GRATUIT' : 'Easybox ' + money(cfg.ebox) + ' · acasă ' + money(cfg.home);
      $('[data-nvs-total]').textContent = money(r.total) + (r.free ? '' : ' + transport');
      var free = $('[data-nvs-free]');
      free.classList.toggle('is-free', r.free);
      free.textContent = r.free ? '✓ Transport GRATUIT inclus' : 'Mai adaugă produse de ' + money(cfg.free - r.subtotal) + ' pentru transport gratuit.';
      $('[data-nvs-save]').textContent = money(r.save);
      $('[data-nvs-save-note]').textContent = (r.prev ? 'Include reducerea EXTRA a setului și reducerile existente.' : 'Include reducerea EXTRA a setului.') +
        (r.free ? ' Economia de transport și economia TOTALĂ apar în formular, după ce alegi livrarea.' : '');
      cta.disabled = false;
      cta.textContent = r.free ? 'Comandă setul · ' + money(r.total) : 'Comandă setul';
    } else {
      var miss = state.slots.slice(0, state.tier).indexOf(null);
      cta.disabled = true;
      cta.textContent = 'Alege ' + ORD[miss] + ' ' + cfg.noun;
    }
  }

  // ─── galeria categoriei ─────────────────────────────────────────────────────
  var data = { items: [], pages: null, loaded: 0, loading: null, done: false, error: false };
  // Reincercare automata (retea instabila / limitare temporara a serverului): 3 incercari, 1,5 s si 4 s pauza.
  function getJSON(url, tries) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .catch(function (e) {
        if (tries <= 1) throw e;
        return new Promise(function (ok) { setTimeout(ok, tries === 3 ? 1500 : 4000); }).then(function () { return getJSON(url, tries - 1); });
      });
  }
  function loadPage(n) {
    return getJSON('/collections/' + encodeURIComponent(cfg.cat) + '?view=nvx-set&page=' + n, 3)
      .then(function (d) {
        data.pages = d.pages || 1; data.loaded = n;
        Array.prototype.push.apply(data.items, d.items || []);
        // Produsul paginii vine din pagina curenta (pret/stoc proaspete); in galerie folosim aceleasi date.
        if (n >= data.pages) data.done = true;
      });
  }
  function loadAll() {
    if (data.done) return Promise.resolve();
    if (data.loading) return data.loading;
    data.error = false;
    data.loading = (function next(n) {
      return loadPage(n).then(function () { refreshGrid(); if (!data.done) return next(n + 1); });
    })(data.loaded + 1).catch(function () { data.error = true; refreshGrid(); }).then(function () { data.loading = null; });
    return data.loading;
  }

  var norm = function (s) { return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase(); };
  var view = { list: [], shown: 0 };
  function filtered() {
    var q = norm($('[data-nvs-search]').value).trim();
    var words = q ? q.split(/\s+/) : [];
    return data.items.filter(function (it) {
      if (!words.length) return true;
      var hay = norm(it.t + ' ' + (it.s || ''));
      return words.every(function (w) { return hay.indexOf(w) > -1; });
    });
  }
  function card(it) {
    var idx = state.picking;
    var ok = canTake(it, idx);
    var cur = state.slots[idx] && state.slots[idx].v === it.v;
    return '<li><button type="button" class="nvs-card' + (cur ? ' is-cur' : '') + '" data-nvs-v="' + it.v + '"' + (ok ? '' : ' disabled') + '>' +
      img(it, 'nvs-card__img') +
      '<span class="nvs-card__t">' + esc(it.t) + '</span>' + (it.s ? '<span class="nvs-card__s">Cod ' + esc(it.s) + '</span>' : '') +
      '<span class="nvs-card__p">' + (it.c > it.p ? '<del>' + money(it.c) + '</del> ' : '') + '<b>' + money(it.p) + '</b></span>' +
      (ok ? '' : '<span class="nvs-card__set">Stoc insuficient</span>') +
      (cur ? '<span class="nvs-card__cur">Ales acum</span>' : '') + '</button></li>';
  }
  function more() {
    var grid = $('[data-nvs-grid]');
    var next = view.list.slice(view.shown, view.shown + CHUNK);
    if (next.length) grid.insertAdjacentHTML('beforeend', next.map(card).join(''));
    view.shown += next.length;
  }
  function count() {
    var n = view.list.length, q = $('[data-nvs-search]').value.trim();
    var t = q ? n + (n === 1 ? ' model găsit' : ' modele găsite') : n + ' modele ' + cfg.catTitle;
    if (!data.done && !data.error) t += ' · se încarcă restul…';
    var el = $('[data-nvs-count]');
    el.textContent = t;
    if (data.error) el.insertAdjacentHTML('beforeend', ' · <span class="nvs-err">Nu am putut încărca toate modelele.</span> <button type="button" class="nvs-retry" data-nvs-retry>Încearcă din nou</button>');
  }
  function refreshGrid(reset) {
    if ($('[data-nvs-modal]').hidden) return;
    var sc = $('[data-nvs-scroll]');
    // Datele noi se adauga doar la final, deci ce vede deja clienta ramane neschimbat (fara reset la incarcare).
    view.list = filtered();
    if (reset) { $('[data-nvs-grid]').innerHTML = ''; view.shown = 0; sc.scrollTop = 0; }
    while (view.shown < CHUNK && view.shown < view.list.length) more();
    if (sc.scrollTop + sc.clientHeight > sc.scrollHeight - 700) more();
    count();
  }

  var lastFocus = null;
  function openGallery(idx) {
    state.picking = idx;
    var m = $('[data-nvs-modal]');
    $('[data-nvs-modal-title]').textContent = 'Alege ' + ORD[idx] + ' ' + cfg.noun;
    $('[data-nvs-modal-sub]').innerHTML = 'Alegi liber orice model ' + esc(cfg.catTitle) + ' · prețul setului se actualizează automat';
    $('[data-nvs-search]').value = '';
    lastFocus = document.activeElement;
    m.hidden = false;
    document.documentElement.classList.add('nvs-lock');
    sbar();
    $('[data-nvs-grid]').innerHTML = ''; view.shown = 0; $('[data-nvs-scroll]').scrollTop = 0;
    $('[data-nvs-count]').textContent = data.items.length ? '' : 'Se încarcă modelele…';
    // Modalul apare in acest cadru; cardurile in urmatorul (clientei i se raspunde imediat la apasare).
    later(function () { refreshGrid(true); loadAll(); $('[data-nvs-close]').focus(); });
  }
  function later(fn) { (window.requestAnimationFrame || setTimeout)(function () { setTimeout(fn, 0); }); }
  function closeGallery() {
    $('[data-nvs-modal]').hidden = true;
    document.documentElement.classList.remove('nvs-lock');
    setTimeout(sbar, 0);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function choose(v) {
    var it = data.items.filter(function (x) { return x.v === v; })[0];
    if (!it || !canTake(it, state.picking)) return;
    state.slots[state.picking] = it;
    var idx = state.picking;
    closeGallery();
    later(function () {
      render();
      var row = root.querySelectorAll('.nvs-slot')[idx];
      if (row) { var b = row.querySelector('[data-nvs-pick]'); if (b) b.focus({ preventScroll: true }); }
    });
  }

  // ─── comanda: cos + formularul EasySell existent ──────────────────────────
  function msg(t) { var m = $('[data-nvs-msg]'); m.textContent = t || ''; m.hidden = !t; }
  function j(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) { var e = new Error(d.description || d.message || 'Eroare'); e.status = r.status; throw e; } return d; }); });
  }
  // Verificare stoc chiar inainte de comanda (pe datele curente ale magazinului, nu pe cele de la incarcarea paginii).
  function recheck(items) {
    var need = {};
    items.forEach(function (it) { need[it.h] = need[it.h] || { it: it, n: 0 }; need[it.h].n++; });
    return Promise.all(Object.keys(need).map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          var v = p && p.variants.filter(function (x) { return x.id === need[h].it.v; })[0];
          return v && v.available ? null : need[h].it.t;
        });
    })).then(function (bad) { return bad.filter(Boolean); });
  }
  function openForm() {
    // Formularul EasySell in modul "cos" (acelasi formular unic ca in cos/sertar): sertarul temei + butonul EasySell din el.
    var cart = window.NuvraPageCart;
    var p = cart && cart.refresh ? Promise.resolve(cart.refresh()) : Promise.resolve();
    return p.then(function () {
      if (cart && cart.open) cart.open();
      var tries = 0;
      (function click() {
        var b = document.querySelector('.ncx-dr__foot .es-popup-button-drawer, .ncx-dr__foot .es-popup-button, .nv-drawer-foot .es-popup-button');
        if (b) { b.click(); return; }
        // EasySell pune butonul in sertar dupa ce acesta se deschide (masurat: cateva secunde); daca nu apare, sertarul ramane deschis cu butonul lui.
        if (++tries < 100) setTimeout(click, 150);
      })();
    });
  }
  function order() {
    var r = compute();
    if (!r.complete) return;
    var cta = $('[data-nvs-cta]');
    cta.disabled = true; cta.textContent = 'Se pregătește comanda…'; msg('');
    var items = state.slots.slice(0, state.tier);
    var setId = 'S' + Date.now().toString(36).toUpperCase();
    recheck(items).then(function (bad) {
      if (bad.length) throw Object.assign(new Error('stoc'), { stock: bad });
      return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (x) { return x.json(); });
    }).then(function (cart) {
      // Un singur set in cos: scoatem un set pregatit anterior (doar liniile setului; restul cosului ramane).
      var updates = {};
      cart.items.forEach(function (l) { if (l.properties && l.properties._nvx_set) updates[l.key] = 0; });
      return Object.keys(updates).length ? j('/cart/update.js', { updates: updates }) : null;
    }).then(function () {
      return j('/cart/add.js', { items: calc(items).lines.map(function (L) {
        return { id: L.it.v, quantity: L.qty, properties: { _nvx_set: setId } };
      }).reverse() });
    }).then(function () {
      return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (x) { return x.json(); })
        .then(function (c) { formCart = c; remember(); }, function () {});
    }).then(function () {
      return openForm();
    }).catch(function (e) {
      if (e.stock) msg('Ne pare rău, ' + e.stock.join(', ') + ' nu mai este disponibil. Te rugăm să alegi alt model.');
      else if (e.status === 422) msg('Unul dintre modelele alese nu mai are stoc suficient. Te rugăm să alegi alt model.');
      else msg('Nu am putut pregăti comanda. Te rugăm să încerci din nou.');
    }).then(function () { render(); });
  }


  // ─── Formularul EasySell: economia TOTALA a setului, dupa metoda de livrare aleasa in formular ─────
  // Sume reale, nu estimari: reducerea EXTRA = reducerile aplicate de Shopify in cos (total_discount pe liniile setului);
  // reducerile existente = pret anterior valid - pret actual (din datele produselor alese); transportul economisit se
  // aduna numai daca totalul cosului dupa reduceri atinge 299 lei SI e selectata o metoda in formular
  // (acasa 29,99 / Easybox 19,99). Caseta apare doar cand in cos exista produse ale setului.
  var known = {};
  function remember() { state.slots.forEach(function (it) { if (it) known[it.v] = it; }); }
  var formCart = null;
  function formBox() {
    var f = document.getElementById('easysell');
    var old = f && f.querySelector('.nvs-es-save');
    if (!f || !formCart) { if (old) old.remove(); return; }
    var set = formCart.items.filter(function (l) { return l.properties && l.properties._nvx_set; });
    if (!set.length) { if (old) old.remove(); return; }
    var prev = 0, extra = 0;
    set.forEach(function (l) {
      var it = known[l.variant_id];
      if (it && it.c > it.p) prev += (it.c - it.p) * l.quantity;
      extra += l.total_discount || 0;
    });
    var free = formCart.total_price >= cfg.free;
    var on = f.querySelector('.es-selected-shipping-line .shipping-name');
    var mode = on ? (/easybox|point/i.test(on.textContent || '') ? 'ebox' : 'home') : null;
    var ship = free && mode ? (mode === 'ebox' ? cfg.ebox : cfg.home) : 0;
    var prod = prev + extra;
    var h = '<p class="nvs-es-save__row"><span>Economisești la produse</span><b>' + money(prod) + '</b></p>';
    if (free) h += mode ? '<p class="nvs-es-save__row"><span>Economisești și transportul (' + (mode === 'ebox' ? 'Easybox' : 'livrare acasă') + ')</span><b>' + money(ship) + '</b></p>'
      : '<p class="nvs-es-save__row nvs-es-save__ok">✓ Transport GRATUIT inclus</p>';
    h += '<p class="nvs-es-save__tot"><span>Economisești în TOTAL</span><strong>' + money(prod + ship) + '</strong></p>';
    var box = old || document.createElement('div');
    box.className = 'nvs-es-save';
    if (box.getAttribute('data-h') !== h) { box.setAttribute('data-h', h); box.innerHTML = h; }
    if (!old) {
      var g = f.querySelector('.es-shipping_options-group');
      if (g && g.parentNode) g.parentNode.insertBefore(box, g.nextSibling); else return;
    }
  }
  // Caseta apare odata cu formularul (date de cos deja pregatite), nu dupa el: fara salt de continut.
  function fastBox() { var n = 0; (function go() { formBox(); if (!document.querySelector('#easysell .nvs-es-save') && ++n < 80) setTimeout(go, 50); })(); }
  function formWatch() {
    remember();
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (x) { return x.json(); })
      .then(function (c) { formCart = c; var tries = 0; (function go() { formBox(); if (!document.querySelector('#easysell .nvs-es-save') && ++tries < 40) setTimeout(go, 150); })(); })
      .catch(function () {});
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('.es-popup-button')) { if (formCart) fastBox(); setTimeout(formWatch, 300); }
    else if (e.target.closest('#easysell .shipping-line')) setTimeout(formBox, 60);
  }, true);
  // EasySell preselecteaza livrarea si redeseneaza lista (elemente noi, nu doar clase schimbate): orice schimbare in
  // formular reactualizeaza caseta (cu mica intarziere, o singura data pe rafala de schimbari).
  var boxTimer = null;
  if ('MutationObserver' in window) new MutationObserver(function (ms) {
    if (!formCart) return;
    // Prima aparitie a livrarii in formular: caseta se insereaza sincron, inainte de afisare (fara salt pentru campurile de sub ea).
    if (!document.querySelector('#easysell .nvs-es-save') && document.querySelector('#easysell .es-shipping_options-group')) { formBox(); return; }
    if (boxTimer) return;
    for (var i = 0; i < ms.length; i++) {
      var t = ms[i].target;
      if (t.closest && t.closest('#easysell') && !t.closest('.nvs-es-save')) {
        boxTimer = setTimeout(function () { boxTimer = null; formBox(); }, 80); return;
      }
    }
  }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });

  // Bara fixa de jos (mobil): vizibila in modul set cand butonul principal nu e pe ecran.
  var seen = { cta: false, tiers: false };
  function sbar() {
    var on = state.tier > 1 && !seen.cta && !seen.tiers && $('[data-nvs-modal]').hidden;
    $('[data-nvs-sbar]').classList.toggle('on', on);
    document.body.classList.toggle('nvs-has-sbar', on);
  }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { seen.cta = es[0].isIntersecting; sbar(); }, { threshold: 0 }).observe($('[data-nvs-cta]'));
    new IntersectionObserver(function (es) { seen.tiers = es[0].isIntersecting; sbar(); }, { threshold: 0 }).observe($('[data-nvs-tiers]'));
  }
  $('[data-nvs-sbar-btn]').addEventListener('click', function () {
    var mi = state.slots.slice(0, state.tier).indexOf(null);
    if (mi > -1) openGallery(mi); else order();
  });

  // ─── evenimente ────────────────────────────────────────────────────────────
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-nvs-retry]')) { loadAll(); count(); return; }
    var t = e.target.closest('[data-nvs-tier],[data-nvs-pick],[data-nvs-cta],[data-nvs-close],[data-nvs-v]');
    if (!t) { if (e.target === $('[data-nvs-modal]')) closeGallery(); return; }
    if (t.hasAttribute('data-nvs-tier')) {
      state.tier = Number(t.getAttribute('data-nvs-tier'));
      // Pozitiile ramase peste numarul ales se pastreaza (clienta poate reveni la 3 fara sa reia selectia).
      render(); sbar();
    } else if (t.hasAttribute('data-nvs-pick')) openGallery(Number(t.getAttribute('data-nvs-pick')));
    else if (t.hasAttribute('data-nvs-cta')) order();
    else if (t.hasAttribute('data-nvs-close')) closeGallery();
    else if (t.hasAttribute('data-nvs-v')) choose(Number(t.getAttribute('data-nvs-v')));
  });
  var timer;
  $('[data-nvs-search]').addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(function () { refreshGrid(true); }, 120); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !$('[data-nvs-modal]').hidden) closeGallery(); });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { if (es[0].isIntersecting && !$('[data-nvs-modal]').hidden) { more(); count(); } },
      { root: $('[data-nvs-scroll]'), rootMargin: '600px 0px' }).observe($('[data-nvs-more]'));
  }

  // Produsul paginii poate fi ales si ca produs 2/3 (acelasi model de mai multe ori, cat permite stocul).
  render();
  window.NuvraSet = { state: function () { return { tier: state.tier, slots: state.slots, calc: compute() }; }, extraOf: extraOf, calc: calc };
})();
